import { call, put, takeEvery } from "redux-saga/effects";
import * as types from "./actionTypes";
import { CommonConsole } from "../../../components/Common/CommonFunction";
import {
    ERPUrl_List_API,
    ERPUrl_Single_Get_API,
    ERPUrl_Save_API,
    ERPUrl_Update_API,
    ERPUrl_Delete_API,
} from "../../../helpers/backend_helper";
import {
    getERPUrlListSuccess,
    editERPUrlIDSuccess,
    saveERPUrlMaster_Success,
    updateERPUrlIDSuccess,
    deleteERPUrlSuccess,
    getERPUrlDetailsByMasterIdSuccess,
    erpUrlApiError,
} from "./action";

function* fetchERPUrlList() {
    try {
        const response = yield call(ERPUrl_List_API);
        yield put(getERPUrlListSuccess(response));
    } catch (error) {
        CommonConsole(error);
        yield put(erpUrlApiError(error));
    }
}

// Edit from the list page: master page reads editValue[0], so Data must be an array.
function* editERPUrl({ payload }) {
    
    try {
        const id = payload.editId ?? payload.id;
        const response = yield call(ERPUrl_Single_Get_API, id);
        const data = (Array.isArray(response.Data) ? response.Data : [response.Data])
            .map((r) => ({ ...r, id: r?.id ?? r?.Id ?? payload.editId }));
        yield put(editERPUrlIDSuccess({ ...response, Data: data, pageMode: payload.btnmode }));
    } catch (error) {
        CommonConsole(error);
        yield put(erpUrlApiError(error));
    }
}

function* saveERPUrl({ payload }) {
    try {
        const response = yield call(ERPUrl_Save_API, payload.jsonBody);
        yield put(saveERPUrlMaster_Success(response));
    } catch (error) {
        CommonConsole(error);
        yield put(erpUrlApiError(error));
    }
}

function* updateERPUrl({ payload }) {
    try {
        const response = yield call(ERPUrl_Update_API, payload.jsonBody, payload.updateId);
        yield put(updateERPUrlIDSuccess(response));
    } catch (error) {
        CommonConsole(error);
        yield put(erpUrlApiError(error));
    }
}

function* deleteERPUrl({ payload }) {
    try {
        const response = yield call(ERPUrl_Delete_API, payload.deleteId);
        yield put(deleteERPUrlSuccess(response));
    } catch (error) {
        CommonConsole(error);
        yield put(erpUrlApiError(error));
    }
}

// Party-wise grid rows: response.Data.PartyDetails -> [{ PartyId, Urls }]
function* fetchERPUrlDetailsByMaster({ payload }) {
    try {
        const response = yield call(ERPUrl_Single_Get_API, payload.masterId);
        yield put(getERPUrlDetailsByMasterIdSuccess(response?.Data?.PartyDetails || []));
    } catch (error) {
        CommonConsole(error);
        yield put(erpUrlApiError(error));
    }
}

function* ERPUrlSaga() {
    yield takeEvery(types.GET_ERPURL_LIST, fetchERPUrlList);
    yield takeEvery(types.EDIT_ERPURL_ID, editERPUrl);
    yield takeEvery(types.SAVE_ERPURL_MASTER, saveERPUrl);
    yield takeEvery(types.UPDATE_ERPURL_ID, updateERPUrl);
    yield takeEvery(types.DELETE_ERPURL_ID, deleteERPUrl);
    yield takeEvery(types.GET_ERPURL_DETAILS_BY_MASTER, fetchERPUrlDetailsByMaster);
}

export default ERPUrlSaga;